import { memo } from "react";

import type { HotelI18n_DesignPageQuery, LangCode } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import { FeatureIslandHeader } from "@/components/features/_layouts";

import { MagazineEditor } from "../../../../_shared/ui/component/editor/magazine-editor";
import { DesignMagazineHeaderRightChildren } from "../../../../_shared/ui/component/header/right-children";
import { getMagazineEditPageUrl } from "../../../../_shared/utils/get-magazine-edit-page-url";
import { useInitialized } from "../../model/usecase/use-initialized";

type Props = {
	hotelID: string;
	langCode: LangCode;
	data: HotelI18n_DesignPageQuery;
};

export const DesignMagazineHotelArticleI18nEditPresenter = memo(({ hotelID, langCode, data: _data }: Props) => {
	const { articleHTML, data, isDirty, isValid, onUpdate, onSetArticleHTML } = useInitialized({
		hotelID,
		langCode,
		data: _data,
	});
	const { name } = data.hotelI18n;

	useTransitionBlock(isDirty);

	return (
		<div>
			<FeatureIslandHeader
				className="top-0"
				title="施設記事の編集"
				activeLangCode={langCode}
				navigator={{
					default: getMagazineEditPageUrl({
						hotelID,
						magazineResourceID: undefined,
						magazineResourceType: "AboutHotel",
					}),
					i18n: (lang) =>
						getMagazineEditPageUrl({
							hotelID,
							magazineResourceID: undefined,
							magazineResourceType: "AboutHotel",
							langCode: lang,
						}),
				}}
				rightChildren={<DesignMagazineHeaderRightChildren isValid={isValid} onUpdate={onUpdate} />}
			/>

			{Boolean(articleHTML) && (
				<MagazineEditor
					resourceName={name ?? ""}
					tiptapEditorProps={{
						content: articleHTML,
						hotelID,
						handleEditorContentChange: onSetArticleHTML,
					}}
				/>
			)}
		</div>
	);
});

DesignMagazineHotelArticleI18nEditPresenter.displayName = "DesignMagazineHotelArticleI18nEditPresenter";
